import React, { Component } from 'react';

export default class Headline extends Component {
	render() {
		return [
			<h2 key="0">
				<span>
					<em>{this.props.text}</em>
				</span>
			</h2>
		];
	}
}


// WEBPACK FOOTER //
// ./src/Headline.js